import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from 'src/app/core/auth/auth.service';
import { Credentials } from 'src/app/core/models/credentials';
import { ConnectiveLoginService } from 'src/app/core/services/connective-login.service';
import { QuestionLoginComponent } from '../question-login/question-login.component';

@Component({
  selector: 'app-erp-scontract',
  templateUrl: './erp-scontract.component.html',
  styleUrls: ['./erp-scontract.component.scss']
})
export class ErpSContractComponent implements OnInit {
  erpToken: string;
  domain: string;
  credentials: Credentials = new Credentials('', false);
  isRemember: boolean;
  private currentUserSubject: BehaviorSubject<any>;
  username: string;
  password: string;

  constructor(
    private activeRouter: ActivatedRoute,
    private connectiveLoginService: ConnectiveLoginService,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router,
    private authService: AuthService,
    public dialog: MatDialog,

  ) {
    this.activeRouter.queryParams.subscribe(params => {
      if (params['token']) {
        this.erpToken = params['token'];
        this.domain = params['domain'];
      }
    })
    this.currentUserSubject = new BehaviorSubject<any>('');
  }

  ngOnInit() {
    this.spinnerService.show();
    this.connectiveLoginService.erpToken(this.erpToken, this.domain).subscribe(response => {
      //login he thong
      if (response.data.message === 'connected') {
        this.authService.storeAccessToken(response.data.auth.token, this.isRemember);
        localStorage.setItem('tenantId', response.data.auth.tenantId);
        localStorage.setItem('userId', response.data.auth.userId);
        localStorage.setItem('userName', response.data.auth.username);
        localStorage.setItem('fullName', response.data.auth.fullName);
        localStorage.setItem('enterpriseId', response.data.auth.enterpriseId);
        localStorage.setItem('permissions', JSON.stringify(response.data.auth.permissions));
        localStorage.setItem('featureStatus', JSON.stringify(response.data.featureStatus));
        localStorage.setItem('defaultPermission', JSON.stringify(response.data.auth.defaultPermission));
        localStorage.setItem('userType', response.data.auth.userType);
        localStorage.setItem('isParent', response.data.auth.isParent);
        this.currentUserSubject.next(response.data.auth.token);

        if (this.isRemember === true) {
          this.credentials = new Credentials(this.username, this.isRemember);
          localStorage.setItem('credentialsEnt', JSON.stringify(this.credentials));
        } else {
          localStorage.removeItem('credentialsEnt');
        }
        this.router.navigate(['home-enterprise']);
      }

      else if (response.data.message === 'not_connected') {
        this.spinnerService.hide();
        document.location.href = response.data.redirectUrl
      }

      else if (response.data.message === 'token_invalid') {
        this.spinnerService.hide();
        this.questionUserLogin();
      }

      else if (response.data.message === 'not_found') {
        this.spinnerService.hide();
        this.questionUserLoginError();
      }

      else if (response.data.message === 'is_locked') {
        this.spinnerService.hide();
        this.questionUserLoginLocked();
      }

      else {
        this.spinnerService.hide();
        this.router.navigate(['/404'])
      }
    }, error => {
      this.spinnerService.hide();
      this.router.navigate(['/404'])
    })
  }


  questionUserLogin() {
    const dialogRe = this.dialog.open(QuestionLoginComponent, {
      width: '550px',
      maxWidth: '80vw',
      panelClass: 'scontract-overlay-dialog',
      data: {formType: 'login-token-invalid'}
    });
    dialogRe.afterClosed().subscribe(data => {
      this.router.navigate(['enterprise-login']);
    })
  }

  questionUserLoginError() {
    const dialogRe = this.dialog.open(QuestionLoginComponent, {
      width: '550px',
      maxWidth: '80vw',
      panelClass: 'scontract-overlay-dialog',
      data: {formType: 'login-token-error-home'}
    });
    dialogRe.afterClosed().subscribe(data => {
      this.router.navigate(['']);
    })
  }

  questionUserLoginLocked() {
    const dialogRe = this.dialog.open(QuestionLoginComponent, {
      width: '550px',
      maxWidth: '80vw',
      panelClass: 'scontract-overlay-dialog',
      data: {formType: 'login-token-locked'}
    });
    dialogRe.afterClosed().subscribe(data => {
      this.router.navigate(['']);
    })
  }
}
